/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".scroll-to-top[_ngcontent-%COMP%]{position:fixed;bottom:15px;right:15px;opacity:0;transition:.2s ease-in-out}.show-scrollTop[_ngcontent-%COMP%]{opacity:1;transition:.2s ease-in-out}button.back-to-top[_ngcontent-%COMP%]{width:60px;height:60px;position:fixed;z-index:999;right:20px;bottom:20px;background:#337ab7;border-radius:30px;padding-left:10px;padding-top:7px;font-size:40px;color:#fff;outline:0}\n/*# sourceMappingURL=scroll-top.component.css.map*/"];
export { styles as styles };
